// import React, { useState, useMemo } from "react";
// import "../Home/theme.css"; // Import the CSS file
// import toneblueg from "../../Assesst/laminance blue tone glossy.png";
// import toneblue from "../../Assesst/laminance blue tone matte.png";
// import CelestialBlue from "../../Assesst/laminance Celestial Blueglossy.png";
// import CelestialBlueg from "../../Assesst/laminance Celestial Blue matee.png";
// import pabblegrayg from "../../Assesst/Laminance Pabble grayG.png"
// import pabblegray from "../../Assesst/Laminance Pabble grayM.png"
// import Warmgrayg from "../../Assesst/Laminance Warm grayG .png"
// import Warmgray from "../../Assesst/Laminance Warm grayM.png"
// import Mossgrayg from "../../Assesst/Laminance Moss gray G.png"
// import Mossgray from "../../Assesst/Laminance Moss gray M.png"
// import Palegrayg from "../../Assesst/Laminance palegrayg.png"
// import Palegray from "../../Assesst/Laminance palegraym.png"
// import folkestonefrayg  from "../../Assesst/folkestonefrayg.png"
// import folkestonefray from "../../Assesst/folkestonefraym.png"
// import Platinum from "../../Assesst/Platinumgmm.png"
// import Platinumg from "../../Assesst/Platinumgg.png"
// import smokeg from "../../Assesst/smokeg.png"
// import smoke from "../../Assesst/smoke.png"
// import silvergrayg from "../../Assesst/silvergrayg.png"
// import silvergray from "../../Assesst/silvergray.png"
// import Ceramicg from "../../Assesst/Ceramicg.png"
// import Ceramic from "../../Assesst/Ceramic.png"
// import Champagneg from "../../Assesst/Champagneg.png"
// import Champagne from "../../Assesst/Champagne.png"
// import MysoreIvoryg from "../../Assesst/MysoreIvoryg.png"
// import MysoreIvory from "../../Assesst/MysoreIvory.png"
// import InteriorWhiteg from "../../Assesst/InteriorWhiteg.png"
// import InteriorWhite from "../../Assesst/InteriorWhite.png"
// import SnowWhiteg from "../../Assesst/SnowWhiteg.png"
// import SnowWhite from "../../Assesst/SnowWhite.png"
// import RoyalWhiteg from "../../Assesst/RoyalWhiteg.png"
// import RoyalWhite from "../../Assesst/RoyalWhite.png"
// import CandyWhiteg from "../../Assesst/CandyWhiteg.png"
// import CandyWhite from "../../Assesst/CandyWhite.png"
// import WhiteLilyg from "../../Assesst/WhiteLilyg.png"
// import WhiteLily from "../../Assesst/WhiteLily.png"
// import RoyalGreyg from "../../Assesst/RoyalGrey.png"
// import RoyalGrey from "../../Assesst/RoyalGreym.png"
// import AshGreyg from "../../Assesst/AshGreyg.png"
// import AshGrey from "../../Assesst/AshGrey.png"
// import GreyStoneg from "../../Assesst/GreyStoneg.png"
// import GreyStone from "../../Assesst/GreyStone.png"
// import PumicGreyg from "../../Assesst/PumicGreyg.png"
// import PumicGrey from "../../Assesst/matem.png"
// import DoveGreyg from "../../Assesst/DoveGreyg.png"
// import DoveGrey from "../../Assesst/DoveGrey.png"
// // import GothicGreyg from "../../Assesst/GothicGreyg.png"
// // import GothicGrey from "../../Assesst/GothicGrey.png"
// import MistyGreyg from "../../Assesst/MistyGreyg.png"
// import MistyGrey from "../../Assesst/MistyGrey.png"
// import AutumnLeafg from "../../Assesst/AutumnLeafg.png"
// import AutumnLeaf from "../../Assesst/AutumnLeaf.png"
// import CobbleStoneg from "../../Assesst/CobbleStoneg.png"
// import CobbleStone from "../../Assesst/CobbleStone.png"
// import Slateg from "../../Assesst/Slateg.png"
// import Slate from "../../Assesst/Slate.png"
// import PearlBlackg from "../../Assesst/PearlBlackg.png"
// import PearlBlack from "../../Assesst/PearlBlack.png"
// import Blackg from "../../Assesst/Blackg.png"
// import Black from "../../Assesst/Black.png"
// import Almondg from "../../Assesst/Almondg.png"
// import Almond from "../../Assesst/Almond.png"
// import Corng from "../../Assesst/Corng.png"
// import Corn from "../../Assesst/Corn.png"
// import Magnoliag from "../../Assesst/Magnolia.png"
// import Magnolia from "../../Assesst/Magnoliag.png"
// import BritishBuffg from "../../Assesst/BritishBuffg.png"
// import BritishBuff from "../../Assesst/BritishBuff.png"
// import LightBeigeg from "../../Assesst/LightBeigeg.png"
// import LightBeige from "../../Assesst/LightBeige.png"
// import Peanutg from "../../Assesst/Peanutg.png"
// import Peanut from "../../Assesst/Peanut.png"
// import Barleyg from "../../Assesst/Barleyg.png"
// import Barley from "../../Assesst/Barley.png"
// import Oysterg from "../../Assesst/Oysterg.png"
// import Oyster from "../../Assesst/Oyster.png"
// import IrishCreamg from "../../Assesst/IrishCreamg.png"
// import IrishCream from "../../Assesst/IrishCream.png"
// import Beigeg from "../../Assesst/Beigeg.png"
// import Beige from "../../Assesst/Beige.png"
// import Sandalg from "../../Assesst/Sandalg.png"
// import Sandal from "../../Assesst/Sandal.png"
// import Khakig from "../../Assesst/Khakig.png"
// import Khaki from "../../Assesst/Khaki.png"
// import Cappucciong from "../../Assesst/Cappucciong.png"
// import Cappuccion from "../../Assesst/Cappuccion.png" 
// import Tang from "../../Assesst/Tang.png"
// import Tan from "../../Assesst/Tan.png" 
// import Larkg from "../../Assesst/Larkg.png"
// import Lark from "../../Assesst/Lark.png" 
// import Browng from "../../Assesst/Browng.png"
// import Brown from "../../Assesst/Brown.png" 
// import Mochag from "../../Assesst/Mochag.png"
// import Mocha from "../../Assesst/Mocha.png" 
// import Chocolateg from "../../Assesst/Chocolateg.png"
// import Chocolate from "../../Assesst/Chocolate.png"



// import CandyWhitegP from "../../Assesst/CandyWhitegP.jpeg"
// import CandyWhiteP from "../../Assesst/CandyWhiteP.jpeg"
// import WhiteLilygP from "../../Assesst/WhiteLilygP.jpeg"
// import WhiteLilyP from "../../Assesst/WhiteLilyP.jpeg"
// import RoyalWhitegP from "../../Assesst/RoyalWhitegP.jpeg"
// import RoyalWhiteP from "../../Assesst/RoyalWhiteP.jpeg"
// import SnowWhitegP from "../../Assesst/SnowWhitegP.jpeg"
// import SnowWhiteP from "../../Assesst/SnowWhiteP.jpeg"
// import InteriorWhitegP from "../../Assesst/InteriorWhitegP.jpeg"
// import InteriorWhiteP from "../../Assesst/InteriorWhiteP.jpeg"
// import MysoreIvorygP from "../../Assesst/MysoreIvorygP.jpeg"
// import MysoreIvoryP from "../../Assesst/MysoreIvoryP.jpeg"
// import ChampagnegP from "../../Assesst/ChampagnegP.jpeg"
// import ChampagneP from "../../Assesst/ChampagneP.jpeg"
// import CeramicgP from "../../Assesst/CeramicgP.jpeg"
// import CeramicP from "../../Assesst/CeramicP.jpeg"
// import silvergraygP from "../../Assesst/silvergraygP.jpeg"
// import silvergrayP from "../../Assesst/silvergrayP.jpeg"
// import smokegP from "../../Assesst/smokegP.jpeg"
// import smokeP from "../../Assesst/smokeP.jpeg"
// import PlatinumgP from "../../Assesst/PlatinumgP.png"
// import PlatinumP from "../../Assesst/PlatinumP.jpeg"
// import folkestonefraygP from "../../Assesst/folkestonefraygP.jpeg"
// import folkestonefrayP from "../../Assesst/folkestonefrayP.jpeg"
// import PalegraygP from "../../Assesst/PalegraygP.jpeg"
// import PalegrayP from "../../Assesst/PalegrayP.jpeg"
// import MossgraygP from "../../Assesst/MossgraygP.jpeg"
// import MossgrayP from "../../Assesst/MossgrayP.jpeg"
// import WarmgraygP from "../../Assesst/WarmgraygP.jpeg"
// import WarmgrayP from "../../Assesst/WarmgrayP.jpeg"
// import pabblegraygP from "../../Assesst/pabblegraygP.jpeg"
// import pabblegrayP from "../../Assesst/pabblegraygP.jpeg"
// import RoyalGreygP from "../../Assesst/RoyalGreyggP.jpeg"
// import RoyalGreyP from "../../Assesst/RoyalGreygP.jpeg"



// import AshGreygP from "../../Assesst/AshGreygP.jpeg"
// import AshGreyP from "../../Assesst/AshGreyP.jpeg"
// import GreyStonegP from "../../Assesst/GreyStonegP.jpeg"
// import GreyStoneP from "../../Assesst/GreyStoneP.jpeg"
// import PumicGreygP from "../../Assesst/PumicGreygP.jpeg"
// import PumicGreyP from "../../Assesst/PumicGreyP.jpeg"
// import DoveGreygP from "../../Assesst/DoveGreygP.jpeg"
// import DoveGreyP from "../../Assesst/DoveGreyP.jpeg"
// import GothicGreygP from "../../Assesst/GothicGreygP.jpeg"
// import GothicGreyP from "../../Assesst/GothicGreyP.jpeg"
// import MistyGreygP from "../../Assesst/MistyGreygP.jpeg"
// import MistyGreyP from "../../Assesst/MistyGreyP.jpeg"
// import AutumnLeafgP from "../../Assesst/AutumnLeafgP.jpeg"
// import AutumnLeafP from "../../Assesst/AutumnLeafP.jpeg"
// import CobbleStonegP from "../../Assesst/CobbleStonegP.jpeg"
// import CobbleStoneP from "../../Assesst/CobbleStoneP.jpeg"
// import SlategP from "../../Assesst/SlategP.jpeg"
// import SlateP from "../../Assesst/SlateP.jpeg"
// import PearlBlackgP from "../../Assesst/PearlBlackgP.jpeg"
// import PearlBlackP from "../../Assesst/PearlBlackP.jpeg"
// import BlackgP from "../../Assesst/BlackgP.jpeg"
// import BlackP from "../../Assesst/BlackP.jpeg"

















// const OrnaMatte = "/assets/Images/Ornamatte-brochure-3[1]_1.jpg";
// const OrnaMatte2 = "/assets/Images/Ornamatte-brochure-3[1]_2.jpg";
// const OrnaMatte3 = "/assets/Images/Ornamatte-brochure-3[1]_3.jpg";
// const OrnaMatte4 = "/assets/Images/Ornamatte-brochure-3[1]_4.jpg";


 

// // phattige 




// const products = [


//   // Shaker - Matte Products (M)
//   { id: 5, name: "21369 Pebble Grey", category: "Shaker", subcategory: "Matte", img: pabblegray },
//   { id: 7, name: "21029 Warm Grey", category: "Shaker", subcategory: "Matte", img: Warmgray },
//   { id: 9, name: "21109 Moss Grey", category: "Shaker", subcategory: "Matte", img: Mossgray },
//   { id: 11, name: "22169 Pale Grey", category: "Shaker", subcategory: "Matte", img: Palegray },
//   { id: 13, name: "21019 Folkstone Grey", category: "Shaker", subcategory: "Matte", img: folkestonefray },
//   { id: 15, name: "21059 Platinum", category: "Shaker", subcategory: "Matte", img: Platinum },
//   { id: 17, name: "21071 Smoke", category: "Shaker", subcategory: "Matte", img: smoke },
//   { id: 19, name: "21069 Silver Grey", category: "Shaker", subcategory: "Matte", img: silvergray },
//   { id: 21, name: "21161 Ceramic", category: "Shaker", subcategory: "Matte", img: Ceramic },
//   { id: 23, name: "21187 Champagne", category: "Shaker", subcategory: "Matte", img: Champagne },
//   { id: 25, name: "24087 Mysore Ivory", category: "Shaker", subcategory: "Matte", img: MysoreIvory },
//   { id: 27, name: "21341 Interior White", category: "Shaker", subcategory: "Matte", img: InteriorWhite },
//   { id: 29, name: "21141 Snow White", category: "Shaker", subcategory: "Matte", img: SnowWhite },
//   { id: 31, name: "21581 Royal White", category: "Shaker", subcategory: "Matte", img: RoyalWhite },
//   { id: 33, name: "21941 Candy White", category: "Shaker", subcategory: "Matte", img: CandyWhite },
//   { id: 35, name: "21081 White Lily", category: "Shaker", subcategory: "Matte", img: WhiteLily },
//   { id: 37, name: "21099 Royal Grey", category: "Shaker", subcategory: "Matte", img: RoyalGrey },
//   { id: 39, name: "21089 Ash Grey", category: "Shaker", subcategory: "Matte", img: AshGrey },
//   { id: 41, name: "21009 Grey Stone", category: "Shaker", subcategory: "Matte", img: GreyStone },
//   { id: 43, name: "21321 Pumic Grey", category: "Shaker", subcategory: "Matte", img: PumicGrey },
//   { id: 45, name: "22079 Dove Grey", category: "Shaker", subcategory: "Matte", img: DoveGrey },
//   // { id: 47, name: "22059 Gothic Grey", category: "Shaker", subcategory: "Matte", img: GothicGrey },
//   { id: 49, name: "21039 Misty Grey", category: "Shaker", subcategory: "Matte", img: MistyGrey },
//   { id: 51, name: "22119 Autumn Leaf", category: "Shaker", subcategory: "Matte", img: AutumnLeaf },
//   { id: 53, name: "22129 Cobble Stone", category: "Shaker", subcategory: "Matte", img: CobbleStone },
//   { id: 55, name: "22099 Slate", category: "Shaker", subcategory: "Matte", img: Slate },
//   { id: 57, name: "22109 Pearl Black", category: "Shaker", subcategory: "Matte", img: PearlBlack },
//   { id: 59, name: "21066 Black", category: "Shaker", subcategory: "Matte", img: Black },
//   { id: 61, name: "21087 Almond", category: "Shaker", subcategory: "Matte", img: Almond },
//   { id: 63, name: "21387 Corn", category: "Shaker", subcategory: "Matte", img: Corn },
//   { id: 65, name: "21017 Magnolia", category: "Shaker", subcategory: "Matte", img: Magnolia },
//   { id: 67, name: "22107 British Buff", category: "Shaker", subcategory: "Matte", img: BritishBuff },
//   { id: 69, name: "21054 Light Beige", category: "Shaker", subcategory: "Matte", img: LightBeige },
//   { id: 71, name: "21061 Peanut", category: "Shaker", subcategory: "Matte", img: Peanut },
//   { id: 73, name: "21051 Barley", category: "Shaker", subcategory: "Matte", img: Barley },
//   { id: 75, name: "21007 Oyster", category: "Shaker", subcategory: "Matte", img: Oyster },
//   { id: 77, name: "21027 Irish Cream", category: "Shaker", subcategory: "Matte", img: IrishCream },
//   { id: 79, name: "21037 Beige", category: "Shaker", subcategory: "Matte", img: Beige },
//   { id: 81, name: "21077 Sandal", category: "Shaker", subcategory: "Matte", img: Sandal },
//   { id: 83, name: "21097 Khaki", category: "Shaker", subcategory: "Matte", img: Khaki },
//   { id: 85, name: "22137 Cappuccion", category: "Shaker", subcategory: "Matte", img: Cappuccion },
//   { id: 87, name: "21127 Tan", category: "Shaker", subcategory: "Matte", img: Tan },
//   { id: 89, name: "22197 Lark", category: "Shaker", subcategory: "Matte", img: Lark },
//   { id: 91, name: "22127 Brown", category: "Shaker", subcategory: "Matte", img: Brown },
//   { id: 93, name: "21038 Mocha", category: "Shaker", subcategory: "Matte", img: Mocha },
//   { id: 95, name: "21028 Chocolate", category: "Shaker", subcategory: "Matte", img: Chocolate },




// { id: 5, name: "21369 Pebble Grey-PS", category: "Petit", subcategory: "Matte", img: pabblegrayP },
// { id: 7, name: "21029 Warm Grey-PS", category: "Petit", subcategory: "Matte", img: WarmgrayP },
// { id: 9, name: "21109 Moss Grey-PS", category: "Petit", subcategory: "Matte", img: MossgrayP },
// { id: 11, name: "22169 Pale Grey-PS", category: "Petit", subcategory: "Matte", img: PalegrayP },
// { id: 13, name: "21019 Folkstone Grey-PS", category: "Petit", subcategory: "Matte", img: folkestonefrayP },
// { id: 15, name: "21059 Platinum-PS", category: "Petit", subcategory: "Matte", img: PlatinumP },
// { id: 17, name: "21071 Smoke-PS", category: "Petit", subcategory: "Matte", img: smokeP },
// { id: 19, name: "21069 Silver Grey-PS", category: "Petit", subcategory: "Matte", img: silvergrayP },
// { id: 21, name: "21161 Ceramic-PS", category: "Petit", subcategory: "Matte", img: CeramicP },
// { id: 23, name: "21187 Champagne-PS", category: "Petit", subcategory: "Matte", img: ChampagneP },
// { id: 25, name: "24087 Mysore Ivory-PS", category: "Petit", subcategory: "Matte", img: MysoreIvoryP },
// { id: 27, name: "21341 Interior White-PS", category: "Petit", subcategory: "Matte", img: InteriorWhiteP },
// { id: 29, name: "21141 Snow White-PS", category: "Petit", subcategory: "Matte", img: SnowWhiteP },
// { id: 31, name: "21581 Royal White-PS", category: "Petit", subcategory: "Matte", img: RoyalWhiteP },
// { id: 33, name: "21941 Candy White-PS", category: "Petit", subcategory: "Matte", img: CandyWhiteP },
// { id: 35, name: "21081 White Lily-PS", category: "Petit", subcategory: "Matte", img: WhiteLilyP },
// { id: 37, name: "21099 Royal Grey-PS", category: "Petit", subcategory: "Matte", img: RoyalGreyP },
// { id: 39, name: "21089 Ash Grey-PS", category: "Petit", subcategory: "Matte", img: AshGreyP },
// { id: 41, name: "21009 Grey Stone-PS", category: "Petit", subcategory: "Matte", img: GreyStoneP },
// { id: 43, name: "21321 Pumic Grey-PS", category: "Petit", subcategory: "Matte", img: PumicGreyP },
// { id: 45, name: "22079 Dove Grey-PS", category: "Petit", subcategory: "Matte", img: DoveGreyP },
// { id: 47, name: "22059 Gothic Grey-PS", category: "Petit", subcategory: "Matte", img: GothicGreyP },
// { id: 49, name: "21039 Misty Grey-PS", category: "Petit", subcategory: "Matte", img: MistyGreyP },
// { id: 51, name: "22119 Autumn Leaf-PS", category: "Petit", subcategory: "Matte", img: AutumnLeafP },
// { id: 53, name: "22129 Cobble Stone-PS", category: "Petit", subcategory: "Matte", img: CobbleStoneP },
// { id: 55, name: "22099 Slate-PS", category: "Petit", subcategory: "Matte", img: SlateP },
// { id: 57, name: "22109 Pearl Black-PS", category: "Petit", subcategory: "Matte", img: PearlBlackP },
// { id: 59, name: "21066 Black-PS", category: "Petit", subcategory: "Matte", img: BlackP },
// // { id: 61, name: "21087 Almond-PS", category: "Petit", subcategory: "Matte", img: AlmondP },
// // { id: 63, name: "21387 Corn-PS", category: "Petit", subcategory: "Matte", img: CornP },
// // { id: 65, name: "21017 Magnolia-PS", category: "Petit", subcategory: "Matte", img: MagnoliaP },
// // { id: 67, name: "22107 British Buff-PS", category: "Petit", subcategory: "Matte", img: BritishBuffP },
// // { id: 69, name: "21054 Light Beige-PS", category: "Petit", subcategory: "Matte", img: LightBeigeP },
// // { id: 71, name: "21061 Peanut-PS", category: "Petit", subcategory: "Matte", img: PeanutP },
// // { id: 73, name: "21051 Barley-PS", category: "Petit", subcategory: "Matte", img: BarleyP },
// // { id: 75, name: "21007 Oyster-PS", category: "Petit", subcategory: "Matte", img: OysterP },
// // { id: 77, name: "21027 Irish Cream-PS", category: "Petit", subcategory: "Matte", img: IrishCreamP },
// // { id: 79, name: "21037 Beige-PS", category: "Petit", subcategory: "Matte", img: BeigeP },
// // { id: 81, name: "21077 Sandal-PS", category: "Petit", subcategory: "Matte", img: SandalP },
// // { id: 83, name: "21097 Khaki-PS", category: "Petit", subcategory: "Matte", img: KhakiP },
// // { id: 85, name: "22137 Cappuccion-PS", category: "Petit", subcategory: "Matte", img: CappuccionP },
// // { id: 87, name: "21127 Tan-PS", category: "Petit", subcategory: "Matte", img: TanP },
// // { id: 89, name: "22197 Lark-PS", category: "Petit", subcategory: "Matte", img: LarkP },
// // { id: 91, name: "22127 Brown-PS", category: "Petit", subcategory: "Matte", img: BrownP },
// // { id: 93, name: "21038 Mocha-PS", category: "Petit", subcategory: "Matte", img: MochaP },
// // { id: 95, name: "21028 Chocolate-PS", category: "Petit", subcategory: "Matte", img: ChocolateP },





//   // Shaker - Gloss Products (G)
//   { id: 6, name: "21369 Pebble Grey", category: "Shaker", subcategory: "Gloss", img: pabblegrayg },
//   { id: 8, name: "21029 Warm Grey", category: "Shaker", subcategory: "Gloss", img: Warmgrayg },
//   { id: 10, name: "21109 Moss Grey", category: "Shaker", subcategory: "Gloss", img: Mossgrayg },
//   { id: 12, name: "22169 Pale Grey", category: "Shaker", subcategory: "Gloss", img: Palegrayg },
//   { id: 14, name: "21019 Folkstone Grey", category: "Shaker", subcategory: "Gloss", img: folkestonefrayg },
//   { id: 16, name: "21059 Platinum", category: "Shaker", subcategory: "Gloss", img: Platinumg },
//   { id: 18, name: "21071 Smoke", category: "Shaker", subcategory: "Gloss", img: smokeg },
//   { id: 20, name: "21069 Silver Grey", category: "Shaker", subcategory: "Gloss", img: silvergrayg },
//   { id: 22, name: "21161 Ceramic", category: "Shaker", subcategory: "Gloss", img: Ceramicg },
//   { id: 24, name: "21187 Champagne", category: "Shaker", subcategory: "Gloss", img: Champagneg },
//   { id: 26, name: "24087 Mysore Ivory", category: "Shaker", subcategory: "Gloss", img: MysoreIvoryg },
//   { id: 28, name: "21341 Interior White", category: "Shaker", subcategory: "Gloss", img: InteriorWhiteg },
//   { id: 30, name: "21141 Snow White", category: "Shaker", subcategory: "Gloss", img: SnowWhiteg },
//   { id: 32, name: "21581 Royal White", category: "Shaker", subcategory: "Gloss", img: RoyalWhiteg },
//   { id: 34, name: "21941 Candy White", category: "Shaker", subcategory: "Gloss", img: CandyWhiteg },
//   { id: 36, name: "21081 White Lily", category: "Shaker", subcategory: "Gloss", img: WhiteLilyg },
//   { id: 38, name: "21099 Royal Grey", category: "Shaker", subcategory: "Gloss", img: RoyalGreyg },
//   { id: 40, name: "21089 Ash Grey", category: "Shaker", subcategory: "Gloss", img: AshGreyg },
//   { id: 42, name: "21009 Grey Stone", category: "Shaker", subcategory: "Gloss", img: GreyStoneg },
//   { id: 44, name: "21321 Pumic Grey", category: "Shaker", subcategory: "Gloss", img: PumicGreyg },
//   { id: 46, name: "22079 Dove Grey", category: "Shaker", subcategory: "Gloss", img: DoveGreyg },
//   // { id: 48, name: "22059 Gothic Grey", category: "Shaker", subcategory: "Gloss", img: GothicGreyg },
//   { id: 50, name: "21039 Misty Grey", category: "Shaker", subcategory: "Gloss", img: MistyGreyg },
//   { id: 52, name: "22119 Autumn Leaf", category: "Shaker", subcategory: "Gloss", img: AutumnLeafg },
//   { id: 54, name: "22129 Cobble Stone", category: "Shaker", subcategory: "Gloss", img: CobbleStoneg },
//   { id: 56, name: "22099 Slate", category: "Shaker", subcategory: "Gloss", img: Slateg },
//   { id: 58, name: "22109 Pearl Black", category: "Shaker", subcategory: "Gloss", img: PearlBlackg },
//   { id: 60, name: "21066 Black", category: "Shaker", subcategory: "Gloss", img: Blackg },
//   { id: 62, name: "21087 Almond", category: "Shaker", subcategory: "Gloss", img: Almondg },
//   { id: 64, name: "21387 Corn", category: "Shaker", subcategory: "Gloss", img: Corng },
//   { id: 66, name: "21017 Magnolia", category: "Shaker", subcategory: "Gloss", img: Magnoliag },
//   { id: 68, name: "22107 British Buff", category: "Shaker", subcategory: "Gloss", img: BritishBuffg },
//   { id: 70, name: "21054 Light Beige", category: "Shaker", subcategory: "Gloss", img: LightBeigeg },
//   { id: 72, name: "21061 Peanut", category: "Shaker", subcategory: "Gloss", img: Peanutg },
//   { id: 74, name: "21051 Barley", category: "Shaker", subcategory: "Gloss", img: Barleyg },
//   { id: 76, name: "21007 Oyster", category: "Shaker", subcategory: "Gloss", img: Oysterg },
//   { id: 78, name: "21027 Irish Cream", category: "Shaker", subcategory: "Gloss", img: IrishCreamg },
//   { id: 80, name: "21037 Beige", category: "Shaker", subcategory: "Gloss", img: Beigeg },
//   { id: 82, name: "21077 Sandal", category: "Shaker", subcategory: "Gloss", img: Sandalg },
//   { id: 84, name: "21097 Khaki", category: "Shaker", subcategory: "Gloss", img: Khakig },
//   { id: 86, name: "22137 Cappuccion", category: "Shaker", subcategory: "Gloss", img: Cappucciong },
//   { id: 88, name: "21127 Tan", category: "Shaker", subcategory: "Gloss", img: Tang },
//   { id: 90, name: "22197 Lark", category: "Shaker", subcategory: "Gloss", img: Larkg },
//   { id: 92, name: "22127 Brown", category: "Shaker", subcategory: "Gloss", img: Browng },
//   { id: 94, name: "21038 Mocha", category: "Shaker", subcategory: "Gloss", img: Mochag },
//   { id: 96, name: "21028 Chocolate", category: "Shaker", subcategory: "Gloss", img: Chocolateg },





// { id: 6, name: "21369 Pebble Grey-PS", category: "Petit", subcategory: "Gloss", img: pabblegraygP },
// { id: 8, name: "21029 Warm Grey-PS", category: "Petit", subcategory: "Gloss", img: WarmgraygP },
// { id: 10, name: "21109 Moss Grey-PS", category: "Petit", subcategory: "Gloss", img: MossgraygP },
// { id: 12, name: "22169 Pale Grey-PS", category: "Petit", subcategory: "Gloss", img: PalegraygP },
// { id: 14, name: "21019 Folkstone Grey-PS", category: "Petit", subcategory: "Gloss", img: folkestonefraygP },
// { id: 16, name: "21059 Platinum-PS", category: "Petit", subcategory: "Gloss", img: PlatinumgP },
// { id: 18, name: "21071 Smoke-PS", category: "Petit", subcategory: "Gloss", img: smokegP },
// { id: 20, name: "21069 Silver Grey-PS", category: "Petit", subcategory: "Gloss", img: silvergraygP },
// { id: 22, name: "21161 Ceramic-PS", category: "Petit", subcategory: "Gloss", img: CeramicgP },
// { id: 24, name: "21187 Champagne-PS", category: "Petit", subcategory: "Gloss", img: ChampagnegP },
// { id: 26, name: "24087 Mysore Ivory-PS", category: "Petit", subcategory: "Gloss", img: MysoreIvorygP },
// { id: 28, name: "21341 Interior White-PS", category: "Petit", subcategory: "Gloss", img: InteriorWhitegP },
// { id: 30, name: "21141 Snow White-PS", category: "Petit", subcategory: "Gloss", img: SnowWhitegP },
// { id: 32, name: "21581 Royal White-PS", category: "Petit", subcategory: "Gloss", img: RoyalWhitegP },
// { id: 34, name: "21941 Candy White-PS", category: "Petit", subcategory: "Gloss", img: CandyWhitegP },
// { id: 36, name: "21081 White Lily-PS", category: "Petit", subcategory: "Gloss", img: WhiteLilygP },
// { id: 38, name: "21099 Royal Grey-PS", category: "Petit", subcategory: "Gloss", img: RoyalGreygP },
// { id: 40, name: "21089 Ash Grey-PS", category: "Petit", subcategory: "Gloss", img: AshGreygP },
// { id: 42, name: "21009 Grey Stone-PS", category: "Petit", subcategory: "Gloss", img: GreyStonegP },
// { id: 44, name: "21321 Pumic Grey-PS", category: "Petit", subcategory: "Gloss", img: PumicGreygP },
// { id: 46, name: "22079 Dove Grey-PS", category: "Petit", subcategory: "Gloss", img: DoveGreygP },
// { id: 48, name: "22059 Gothic Grey-PS", category: "Petit", subcategory: "Gloss", img: GothicGreygP },
// { id: 50, name: "21039 Misty Grey-PS", category: "Petit", subcategory: "Gloss", img: MistyGreygP },
// { id: 52, name: "22119 Autumn Leaf-PS", category: "Petit", subcategory: "Gloss", img: AutumnLeafgP },
// { id: 54, name: "22129 Cobble Stone-PS", category: "Petit", subcategory: "Gloss", img: CobbleStonegP },
// { id: 56, name: "22099 Slate-PS", category: "Petit", subcategory: "Gloss", img: SlategP },
// { id: 58, name: "22109 Pearl Black-PS", category: "Petit", subcategory: "Gloss", img: PearlBlackgP },
// { id: 60, name: "21066 Black-PS", category: "Petit", subcategory: "Gloss", img: BlackgP },
// // { id: 62, name: "21087 Almond-PS", category: "Petit", subcategory: "Gloss", img: AlmondgP },
// // { id: 64, name: "21387 Corn-PS", category: "Petit", subcategory: "Gloss", img: CorngP },
// // { id: 66, name: "21017 Magnolia-PS", category: "Petit", subcategory: "Gloss", img: MagnoliagP },
// // { id: 68, name: "22107 British Buff-PS", category: "Petit", subcategory: "Gloss", img: BritishBuffgP },
// // { id: 70, name: "21054 Light Beige-PS", category: "Petit", subcategory: "Gloss", img: LightBeigegP },
// // { id: 72, name: "21061 Peanut-PS", category: "Petit", subcategory: "Gloss", img: PeanutgP },
// // { id: 74, name: "21051 Barley-PS", category: "Petit", subcategory: "Gloss", img: BarleygP },
// // { id: 76, name: "21007 Oyster-PS", category: "Petit", subcategory: "Gloss", img: OystergP },
// // { id: 78, name: "21027 Irish Cream-PS", category: "Petit", subcategory: "Gloss", img: IrishCreamgP },
// // { id: 80, name: "21037 Beige-PS", category: "Petit", subcategory: "Gloss", img: BeigegP },
// // { id: 82, name: "21077 Sandal-PS", category: "Petit", subcategory: "Gloss", img: SandalgP },
// // { id: 84, name: "21097 Khaki-PS", category: "Petit", subcategory: "Gloss", img: KhakigP },
// // { id: 86, name: "22137 Cappuccion-PS", category: "Petit", subcategory: "Gloss", img: CappucciongP },
// // { id: 88, name: "21127 Tan-PS", category: "Petit", subcategory: "Gloss", img: TangP },
// // { id: 90, name: "22197 Lark-PS", category: "Petit", subcategory: "Gloss", img: LarkgP },
// // { id: 92, name: "22127 Brown-PS", category: "Petit", subcategory: "Gloss", img: BrowngP },
// // { id: 94, name: "21038 Mocha-PS", category: "Petit", subcategory: "Gloss", img: MochagP },
// // { id: 96, name: "21028 Chocolate-PS", category: "Petit", subcategory: "Gloss", img: ChocolategP },



//   { id: 97, name: "Ornamatte 1", category: "Ornamatte", subcategory: null, img: OrnaMatte },
//   { id: 98, name: "Ornamatte 2", category: "Ornamatte", subcategory: null, img: OrnaMatte2 },
//   { id: 99, name: "Ornamatte 3", category: "Ornamatte", subcategory: null, img: OrnaMatte3 },
//   { id: 100, name: "Ornamatte 4", category: "Ornamatte", subcategory: null, img: OrnaMatte4 },

  
// ];

// export default function EcommerceFilter() {
//   const [search, setSearch] = useState("");
//   const [fullscreenProduct, setFullscreenProduct] = useState(null);
//   const [sidebarOpen, setSidebarOpen] = useState(false);
//   const [selectedCategory, setSelectedCategory] = useState(null);
//   const [selectedSubcategory, setSelectedSubcategory] = useState(null);
//   const [openDropdown, setOpenDropdown] = useState(null);

//   const categories = useMemo(() => [...new Set(products.map((p) => p.category))], []);

//   const handleCategoryClick = (category) => {
//     if (selectedCategory === category) {
//       // If clicking the same category, clear everything
//       setSelectedCategory(null);
//       setSelectedSubcategory(null);
//       setOpenDropdown(null);
//     } else {
//       // Select new category
//       setSelectedCategory(category);
//       setSelectedSubcategory(null);
//       // Only open dropdown for Shaker category
//       setOpenDropdown(category === "Shaker" ? category : null);
//     }
//     setSidebarOpen(false);
//   };

//   const handleSubcategoryClick = (subcategory) => {
//     setSelectedSubcategory(subcategory);
//     setOpenDropdown(null);
//   };

//   const clearFilters = () => {
//     setSelectedCategory(null);
//     setSelectedSubcategory(null);
//     setOpenDropdown(null);
//     setSearch("");
//   };

//   const filteredProducts = products.filter((p) => {
//     const matchesSearch = p.name.toLowerCase().includes(search.toLowerCase());
    
//     // If no category is selected, show all products
//     if (!selectedCategory) {
//       return matchesSearch;
//     }
    
//     // If a specific category is selected (including Shaker)
//     // Only show products that match exactly that category
//     if (selectedCategory !== "Shaker") {
//       return matchesSearch && p.category === selectedCategory;
//     }
    
//     // For Shaker category
//     if (selectedCategory === "Shaker") {
//       // If subcategory is selected, only show Shaker products with that subcategory
//       if (selectedSubcategory) {
//         return matchesSearch && p.category === "Shaker" && p.subcategory === selectedSubcategory;
//       }
//       // If no subcategory selected, show all Shaker products (both Matte and Gloss)
//       return matchesSearch && p.category === "Shaker";
//     }
    
//     return matchesSearch;
//   });

//   return (
//     <div className="flex flex-col md:flex-row min-h-screen">
//       {/* Mobile Menu Button */}
//       <button
//         className="md:hidden p-4 text-white fixed top-20 left-4 z-40 rounded-lg shadow-lg"
//         style={{
//           backgroundColor: "var(--color-primary-500)",
//         }}
//         onClick={() => setSidebarOpen(true)}
//         aria-label="Open menu"
//       >
//         ☰
//       </button>

//       {/* Sidebar */}
//       <div
//         className={`fixed top-[75px] left-0 h-full w-64 text-white p-6 shadow-lg transform transition-transform duration-300 z-40 overflow-y-auto
//         ${sidebarOpen ? "translate-x-0" : "-translate-x-full"} md:translate-x-0`}
//         style={{
//           backgroundColor: "var(--color-primary-500)",
//         }}
//       >
//         <button
//           className="absolute top-4 right-4 text-2xl font-bold md:hidden"
//           onClick={() => setSidebarOpen(false)}
//           style={{ color: "var(--color-white)" }}
//           aria-label="Close menu"
//         >
//           ✕
//         </button>

//         <h2 className="text-4xl font-extrabold mb-6 text-center md:text-left tracking-wide bell-mt-primary" style={{ color: "var(--color-white)" }}>
//           Styles
//         </h2>

//         <input
//           type="text"
//           placeholder="🔍 Search product..."
//           value={search}
//           onChange={(e) => setSearch(e.target.value)}
//           className="w-full border text-black p-2 rounded-lg mb-6 focus:outline-none focus:ring-2 inter-secondary"
//           style={{
//             borderColor: "var(--border-light)",
//           }}
//         />

//         <div className="space-y-3">
//           {categories.map((category) => (
//             <div key={category} className="relative">
//               <span
//                 onClick={() => handleCategoryClick(category)}
//                 className={`block cursor-pointer font-medium text-base sm:text-sm md:text-sm lg:text-lg truncate px-1 transition inter-secondary ${
//                   selectedCategory === category ? "font-bold underline" : ""
//                 }`}
//                 style={{
//                   color: selectedCategory === category ? "var(--color-accent-500)" : "var(--color-white)",
//                 }}
//               >
//                 {category}
//               </span>
              
//               {/* Dropdown for Shaker category */}
//               {openDropdown === category && category === "Shaker" && (
//                 <div className="mt-2 ml-4 space-y-2 border-l-2 pl-3 border-white/30">
//                   <span
//                     onClick={() => handleSubcategoryClick("Matte")}
//                     className={`block cursor-pointer text-sm transition inter-secondary ${
//                       selectedSubcategory === "Matte" ? "font-bold underline" : ""
//                     }`}
//                     style={{
//                       color: selectedSubcategory === "Matte" ? "var(--color-accent-500)" : "var(--color-white)",
//                     }}
//                   >
//                     Matte
//                   </span>
//                   <span
//                     onClick={() => handleSubcategoryClick("Gloss")}
//                     className={`block cursor-pointer text-sm transition inter-secondary ${
//                       selectedSubcategory === "Gloss" ? "font-bold underline" : ""
//                     }`}
//                     style={{
//                       color: selectedSubcategory === "Gloss" ? "var(--color-accent-500)" : "var(--color-white)",
//                     }}
//                   >
//                     Gloss
//                   </span>
//                 </div>
//               )}
//             </div>
//           ))}
//         </div>
//       </div>

//       {/* Products Grid */}
//       <div className="flex-1 md:ml-64 p-8 overflow-y-auto" style={{ backgroundColor: "var(--color-gray-50)" }}>
//         <h1 className="text-5xl md:text-7xl font-semibold text-center mb-6 p-5 tracking-wide bell-mt-primary" style={{ color: "var(--color-primary-500)" }}>
//           Our Brochure
//         </h1>

//         {/* Active Filter Display */}
//         {(selectedCategory || selectedSubcategory || search) && (
//           <div className="flex justify-center gap-3 mb-6 flex-wrap">
//             {selectedCategory && (
//               <div 
//                 className="flex items-center gap-2 px-4 py-2 rounded-full shadow-md inter-secondary"
//                 style={{
//                   backgroundColor: "var(--color-primary-100)",
//                   color: "var(--color-primary-700)",
//                 }}
//               >
//                 <span className="font-bold">
//                   {selectedCategory}
//                   {selectedSubcategory && ` - ${selectedSubcategory}`}
//                 </span>
//                 <button
//                   onClick={clearFilters}
//                   className="text-lg font-bold transition hover:opacity-70"
//                   style={{ color: "var(--color-primary-700)" }}
//                   aria-label="Clear filter"
//                 >
//                   ✕
//                 </button>
//               </div>
//             )}
//             {search && (
//               <div 
//                 className="flex items-center gap-2 px-4 py-2 rounded-full shadow-md inter-secondary"
//                 style={{
//                   backgroundColor: "var(--color-primary-100)",
//                   color: "var(--color-primary-700)",
//                 }}
//               >
//                 <span className="font-bold">Search: {search}</span>
//                 <button
//                   onClick={() => setSearch("")}
//                   className="text-lg font-bold transition hover:opacity-70"
//                   style={{ color: "var(--color-primary-700)" }}
//                   aria-label="Clear search"
//                 >
//                   ✕
//                 </button>
//               </div>
//             )}
//           </div>
//         )}

//         {/* Products List */}
//         {filteredProducts.length > 0 ? (
//           <div className="grid grid-cols-1 md:grid-cols-2 gap-8 place-items-center">
//             {filteredProducts.map((p) => (
//               <div
//                 key={p.id}
//                 className="w-full md:w-[75%] cursor-pointer flex flex-col items-center bg-white rounded-xl shadow-lg transition transform hover:-translate-y-1 overflow-hidden mx-auto hover:shadow-2xl"
//                 style={{
//                   backgroundColor: "var(--color-white)",
//                   boxShadow: p.category === "Ornamatte" 
//                     ? "0 0 0 4px var(--color-primary-500), 0 20px 25px -5px rgba(0,0,0,0.1)" 
//                     : "var(--shadow-medium)",
//                 }}
//                 onClick={() => setFullscreenProduct(p)}
//               >
//                 <img
//                   src={p.img}
//                   alt={p.name}
//                   loading="lazy"
//                   className="w-full h-auto max-h-[75vh] object-contain rounded-md"
//                 />
//                 <p
//                   className="text-xl font-bold py-4 text-center bell-mt-primary"
//                   style={{
//                     color: p.category === "Ornamatte" ? "var(--color-primary-600)" : "var(--color-gray-900)",
//                   }}
//                 >
//                   {p.name} {p.subcategory && `(${p.subcategory})`}
//                 </p>
//               </div>
//             ))}
//           </div>
//         ) : (
//           <p className="text-lg text-center pt-20 inter-secondary" style={{ color: "var(--color-gray-600)" }}>
//             No products found
//           </p>
//         )}
//       </div>

//       {/* Fullscreen Modal - Centered Image Without Name */}
//       {fullscreenProduct && (
//         <div 
//           className="fixed inset-0 bg-black bg-opacity-90 flex items-center justify-center z-50"
//           onClick={() => setFullscreenProduct(null)}
//         >
//           <button
//             className="absolute top-6 right-6 text-4xl font-bold transition hover:opacity-70 z-50"
//             style={{ color: "var(--color-white)" }}
//             onClick={(e) => {
//               e.stopPropagation();
//               setFullscreenProduct(null);
//             }}
//             aria-label="Close fullscreen view"
//           >
//             ✕
//           </button>
//           <div 
//             onClick={(e) => e.stopPropagation()}
//             className="flex items-center justify-center w-full h-full"
//           >
//             <img
//               src={fullscreenProduct.img}
//               alt={fullscreenProduct.name}
//               loading="lazy"
//               className="max-h-[90%] max-w-[90%] object-contain rounded-xl shadow-xl"
//             />
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }











import React, { useState, useMemo } from "react";
import "../Home/theme.css"; // Import the CSS file
import toneblueg from "../../Assesst/laminance blue tone glossy.png";
import toneblue from "../../Assesst/laminance blue tone matte.png";
import CelestialBlue from "../../Assesst/laminance Celestial Blueglossy.png";
import CelestialBlueg from "../../Assesst/laminance Celestial Blue matee.png";
import pabblegrayg from "../../Assesst/Laminance Pabble grayG.png"
import pabblegray from "../../Assesst/Laminance Pabble grayM.png"
import Warmgrayg from "../../Assesst/Laminance Warm grayG .png"
import Warmgray from "../../Assesst/Laminance Warm grayM.png"
import Mossgrayg from "../../Assesst/Laminance Moss gray G.png"
import Mossgray from "../../Assesst/Laminance Moss gray M.png"
import Palegrayg from "../../Assesst/Laminance palegrayg.png"
import Palegray from "../../Assesst/Laminance palegraym.png"
import folkestonefrayg from "../../Assesst/folkestonefrayg.png"
import folkestonefray from "../../Assesst/folkestonefraym.png"
import Platinum from "../../Assesst/Platinumgmm.png"
import Platinumg from "../../Assesst/Platinumgg.png"
import smokeg from "../../Assesst/smokeg.png"
import smoke from "../../Assesst/smoke.png"
import silvergrayg from "../../Assesst/silvergrayg.png"
import silvergray from "../../Assesst/silvergray.png"
import Ceramicg from "../../Assesst/Ceramicg.png"
import Ceramic from "../../Assesst/Ceramic.png"
import Champagneg from "../../Assesst/Champagneg.png"
import Champagne from "../../Assesst/Champagne.png"
import MysoreIvoryg from "../../Assesst/MysoreIvoryg.png"
import MysoreIvory from "../../Assesst/MysoreIvory.png"
import InteriorWhiteg from "../../Assesst/InteriorWhiteg.png"
import InteriorWhite from "../../Assesst/InteriorWhite.png"
import SnowWhiteg from "../../Assesst/SnowWhiteg.png"
import SnowWhite from "../../Assesst/SnowWhite.png"
import RoyalWhiteg from "../../Assesst/RoyalWhiteg.png"
import RoyalWhite from "../../Assesst/RoyalWhite.png"
import CandyWhiteg from "../../Assesst/CandyWhiteg.png"
import CandyWhite from "../../Assesst/CandyWhite.png"
import WhiteLilyg from "../../Assesst/WhiteLilyg.png"
import WhiteLily from "../../Assesst/WhiteLily.png"
import RoyalGreyg from "../../Assesst/RoyalGrey.png"
import RoyalGrey from "../../Assesst/RoyalGreym.png"
import AshGreyg from "../../Assesst/AshGreyg.png"
import AshGrey from "../../Assesst/AshGrey.png"
import GreyStoneg from "../../Assesst/GreyStoneg.png"
import GreyStone from "../../Assesst/GreyStone.png"
import PumicGreyg from "../../Assesst/PumicGreyg.png"
import PumicGrey from "../../Assesst/matem.png"
import DoveGreyg from "../../Assesst/DoveGreyg.png"
import DoveGrey from "../../Assesst/DoveGrey.png"
import GothicGreyg from "../../Assesst/GothicGreyg.png"
import GothicGrey from "../../Assesst/GothicGrey.png"
import MistyGreyg from "../../Assesst/MistyGreyg.png"
import MistyGrey from "../../Assesst/MistyGrey.png"
import AutumnLeafg from "../../Assesst/AutumnLeafg.png"
import AutumnLeaf from "../../Assesst/AutumnLeaf.png"
import CobbleStoneg from "../../Assesst/CobbleStoneg.png"
import CobbleStone from "../../Assesst/CobbleStone.png"
import Slateg from "../../Assesst/Slateg.png"
import Slate from "../../Assesst/Slate.png"
import PearlBlackg from "../../Assesst/PearlBlackg.png"
import PearlBlack from "../../Assesst/PearlBlack.png"
import Blackg from "../../Assesst/Blackg.png"
import Black from "../../Assesst/Black.png"
import Almondg from "../../Assesst/Almondg.png"
import Almond from "../../Assesst/Almond.png"
import Corng from "../../Assesst/Corng.png"
import Corn from "../../Assesst/Corn.png"
import Magnoliag from "../../Assesst/Magnolia.png"
import Magnolia from "../../Assesst/Magnoliag.png"
import BritishBuffg from "../../Assesst/BritishBuffg.png"
import BritishBuff from "../../Assesst/BritishBuff.png"
import LightBeigeg from "../../Assesst/LightBeigeg.png"
import LightBeige from "../../Assesst/LightBeige.png"
import Peanutg from "../../Assesst/Peanutg.png"
import Peanut from "../../Assesst/Peanut.png"
import Barleyg from "../../Assesst/Barleyg.png"
import Barley from "../../Assesst/Barley.png"
import Oysterg from "../../Assesst/Oysterg.png"
import Oyster from "../../Assesst/Oyster.png"
import IrishCreamg from "../../Assesst/IrishCreamg.png"
import IrishCream from "../../Assesst/IrishCream.png"
import Beigeg from "../../Assesst/Beigeg.png"
import Beige from "../../Assesst/Beige.png"
import Sandalg from "../../Assesst/Sandalg.png"
import Sandal from "../../Assesst/Sandal.png"
import Khakig from "../../Assesst/Khakig.png"
import Khaki from "../../Assesst/Khaki.png"
import Cappucciong from "../../Assesst/Cappucciong.png"
import Cappuccion from "../../Assesst/Cappuccion.png"
import Tang from "../../Assesst/Tang.png"
import Tan from "../../Assesst/Tan.png"
import Larkg from "../../Assesst/Larkg.png"
import Lark from "../../Assesst/Lark.png"
import Browng from "../../Assesst/Browng.png"
import Brown from "../../Assesst/Brown.png"
import Mochag from "../../Assesst/Mochag.png"
import Mocha from "../../Assesst/Mocha.png"
import Chocolateg from "../../Assesst/Chocolateg.png"
import Chocolate from "../../Assesst/Chocolate.png"
import Arcticwhiteg from "../../Assesst/Arcticwhiteg.png"
import Arcticwhite from "../../Assesst/Arcticwhite.png"

// Petit - Matte Images (PM)
import CandyWhiteP from "../../Assesst/CandyWhiteP.jpeg"
import WhiteLilyP from "../../Assesst/WhiteLilyP.png"
import RoyalWhiteP from "../../Assesst/RoyalWhiteP.jpeg"
import SnowWhiteP from "../../Assesst/SnowWhiteP.jpeg"
import InteriorWhiteP from "../../Assesst/InteriorWhiteP.jpeg"
import MysoreIvoryP from "../../Assesst/MysoreIvoryP.jpeg"
import ChampagneP from "../../Assesst/ChampagneP.jpeg"
import CeramicP from "../../Assesst/CeramicP.jpeg"
import silvergrayP from "../../Assesst/silvergrayP.jpeg"
import smokeP from "../../Assesst/smokeP.jpeg"
import PlatinumP from "../../Assesst/PlatinumP.jpeg"
import folkestonefrayP from "../../Assesst/folkestonefrayP.jpeg"
import PalegrayP from "../../Assesst/PalegrayP.png"
import MossgrayP from "../../Assesst/MossgrayP.jpeg"
import WarmgrayP from "../../Assesst/WarmgrayP.jpeg"
import pabblegrayP from "../../Assesst/pabblegrayP.jpeg"
import RoyalGreyP from "../../Assesst/RoyalGreyP.jpeg"
import AshGreyP from "../../Assesst/AshGreyP.jpeg"
import GreyStoneP from "../../Assesst/GreyStoneP.jpeg"
import PumicGreyP from "../../Assesst/PumicGreyP.jpeg"
import DoveGreyP from "../../Assesst/DoveGreyP.jpeg"
import GothicGreyP from "../../Assesst/GothicGreyP.jpeg"
import MistyGreyP from "../../Assesst/MistyGreyP.jpeg"
import AutumnLeafP from "../../Assesst/AutumnLeafP.jpeg"
import CobbleStoneP from "../../Assesst/CobbleStoneP.jpeg"
import SlateP from "../../Assesst/SlateP.jpeg"
import PearlBlackP from "../../Assesst/PearlBlackP.jpeg"
import BlackP from "../../Assesst/BlackP.jpeg"
import ArcticwhiteP from "../../Assesst/ArcticwhiteP.png"

// Petit - Gloss Images (PG)
import CandyWhitegP from "../../Assesst/CandyWhitegP.jpeg"
import WhiteLilygP from "../../Assesst/WhiteLilygP.png"
import RoyalWhitegP from "../../Assesst/RoyalWhitegP.png"
import SnowWhitegP from "../../Assesst/SnowWhitegP.png"
import InteriorWhitegP from "../../Assesst/InteriorWhitegP.jpeg"
import MysoreIvorygP from "../../Assesst/MysoreIvorygP.jpeg"
import ChampagnegP from "../../Assesst/ChampagnegP.jpeg"
import CeramicgP from "../../Assesst/CeramicgP.jpeg"
import silvergraygP from "../../Assesst/silvergraygP.jpeg"
import smokegP from "../../Assesst/smokegP.jpeg"
import PlatinumgP from "../../Assesst/PlatinumgP.png"
import folkestonefraygP from "../../Assesst/folkestonefraygP.jpeg"
import PalegraygP from "../../Assesst/PalegraygP.png"
import MossgraygP from "../../Assesst/MossgraygP.png"
import WarmgraygP from "../../Assesst/WarmgraygP.png"
import pabblegraygP from "../../Assesst/pabblegraygP.jpeg"
import RoyalGreygP from "../../Assesst/RoyalGreygP.png"
import AshGreygP from "../../Assesst/AshGreygP.jpeg"
import GreyStonegP from "../../Assesst/GreyStonegP.jpeg"
import PumicGreygP from "../../Assesst/PumicGreygP.jpeg"
import DoveGreygP from "../../Assesst/DoveGreygP.png"
import GothicGreygP from "../../Assesst/GothicGreygP.jpeg"
import MistyGreygP from "../../Assesst/MistyGreygP.png"
import AutumnLeafgP from "../../Assesst/AutumnLeafgP.jpeg"
import CobbleStonegP from "../../Assesst/CobbleStonegP.jpeg"
import SlategP from "../../Assesst/SlategP.jpeg"
import PearlBlackgP from "../../Assesst/PearlBlackgP.png"
import BlackgP from "../../Assesst/BlackgP.jpeg"
import ArcticwhitegP from "../../Assesst/ArcticwhitegP.png"

// Petit Additional - Matte (PM)
import AlmondP from "../../Assesst/AlmondP.jpeg"
import CornP from "../../Assesst/CornP.jpeg"
import MagnoliaP from "../../Assesst/MagnoliaP.png"
import BritishBuffP from "../../Assesst/BritishBuffP.jpeg"
import LightBeigeP from "../../Assesst/LightBeigeP.jpeg"
import PeanutP from "../../Assesst/PeanutP.jpeg"
import BarleyP from "../../Assesst/BarleyP.jpeg"
import OysterP from "../../Assesst/OysterP.png"
import IrishCreamP from "../../Assesst/IrishCreamP.jpeg"
import BeigeP from "../../Assesst/BeigeP.png"
import SandalP from "../../Assesst/SandalP.jpeg"
import KhakiP from "../../Assesst/KhakiP.jpeg"
import CappuccionP from "../../Assesst/CappuccionP.jpeg"
import TanP from "../../Assesst/TanP.jpeg"
import LarkP from "../../Assesst/LarkP.png"
import BrownP from "../../Assesst/BrownP.jpeg"
import MochaP from "../../Assesst/MochaP.jpeg"
import ChocolateP from "../../Assesst/ChocolateP.jpeg"

// Petit Additional - Gloss (PG)
import AlmondgP from "../../Assesst/AlmondgP.jpeg"
import CorngP from "../../Assesst/CorngP.png"
import MagnoliagP from "../../Assesst/MagnoliagP.png"
import BritishBuffgP from "../../Assesst/BritishBuffgP.png"
import LightBeigegP from "../../Assesst/LightBeigegP.jpeg"
import PeanutgP from "../../Assesst/PeanutgP.jpeg"
import BarleygP from "../../Assesst/BarleygP.jpeg"
import OystergP from "../../Assesst/OystergP.jpeg"
import IrishCreamgP from "../../Assesst/IrishCreamgP.jpeg"
import BeigegP from "../../Assesst/BeigegP.png"
import SandalgP from "../../Assesst/SandalgP.jpeg"
import KhakigP from "../../Assesst/KhakigP.jpeg"
import CappucciongP from "../../Assesst/CappucciongP.jpeg"
import TangP from "../../Assesst/TangP.jpeg"
import LarkgP from "../../Assesst/LarkgP.jpeg"
import BrowngP from "../../Assesst/BrowngP.jpeg"
import MochagP from "../../Assesst/MochagP.jpeg"
import ChocolategP from "../../Assesst/ChocolategP.png"



// Raised center - Matte Images (PM)
import CandyWhiteR from "../../Assesst/CandyWhiteR.jpg"
import WhiteLilyR from "../../Assesst/WhiteLilyR.jpeg"
import RoyalWhiteR from "../../Assesst/RoyalWhiteR.jpg"
import SnowWhiteR from "../../Assesst/SnowWhiteR.jpeg"
import InteriorWhiteR from "../../Assesst/InteriorWhiteR.jpeg"
import MysoreIvoryR from "../../Assesst/MysoreIvoryR.jpeg"
import ChampagneR from "../../Assesst/ChampagneR.jpeg"
import CeramicR from "../../Assesst/CeramicR.jpg"
import silvergrayR from "../../Assesst/silvergrayR.jpg"
import smokeR from "../../Assesst/smokeR.png"
import PlatinumR from "../../Assesst/PlatinumR.jpeg"
import folkestonefrayR from "../../Assesst/folkestonefrayR.png"
import PalegrayR from "../../Assesst/PalegrayR.png"
import MossgrayR from "../../Assesst/MossgrayR.png"
import WarmgrayR from "../../Assesst/WarmgrayR.png"
import pabblegrayR from "../../Assesst/pabblegrayR.png"
import RoyalGreyR from "../../Assesst/RoyalGreyR.png"
import AshGreyR from "../../Assesst/AshGreyR.png"
import GreyStoneR from "../../Assesst/GreyStoneR.png"
import PumicGreyR from "../../Assesst/PumicGreyR.png"
import DoveGreyR from "../../Assesst/DoveGreyR.png"
import GothicGreyR from "../../Assesst/GothicGreyR.png"
import MistyGreyR from "../../Assesst/MistyGreyR.png"
import AutumnLeafR from "../../Assesst/AutumnLeafR.png"
import CobbleStoneR from "../../Assesst/CobbleStoneR.png"
import SlateR from "../../Assesst/SlateR.png"
import PearlBlackR from "../../Assesst/PearlBlackR.jpeg"
import BlackR from "../../Assesst/BlackR.png"
import ArcticwhiteR from "../../Assesst/ArcticwhiteR.png"

// Raised center - Gloss Images (PG)
import CandyWhitegR from "../../Assesst/CandyWhitegR.png"
import WhiteLilygR from "../../Assesst/WhiteLilygR.png"
import RoyalWhitegR from "../../Assesst/RoyalWhitegR.png"
import SnowWhitegR from "../../Assesst/SnowWhitegR.png"
import InteriorWhitegR from "../../Assesst/InteriorWhitegR.png"
import MysoreIvorygR from "../../Assesst/MysoreIvorygR.png"
import ChampagnegR from "../../Assesst/ChampagnegR.png"
import CeramicgR from "../../Assesst/CeramicgR.png"
import silvergraygR from "../../Assesst/silvergraygR.png"
import smokegR from "../../Assesst/smokegR.png"
import PlatinumgR from "../../Assesst/PlatinumgR.png"
import folkestonefraygR from "../../Assesst/folkestonefraygR.png"
import PalegraygR from "../../Assesst/PalegraygR.png"
import MossgraygR from "../../Assesst/MossgraygR.png"
import WarmgraygR from "../../Assesst/WarmgraygR.png"
import pabblegraygR from "../../Assesst/pabblegraygR.png"
import RoyalGreygR from "../../Assesst/RoyalGreygR.png"
import AshGreygR from "../../Assesst/AshGreygR.png"
import GreyStonegR from "../../Assesst/GreyStonegR.png"
import PumicGreygR from "../../Assesst/PumicGreygR.png"
import DoveGreygR from "../../Assesst/DoveGreygR.png"
import GothicGreygR from "../../Assesst/GothicGreygR.png"
import MistyGreygR from "../../Assesst/MistyGreygR.png"
import AutumnLeafgR from "../../Assesst/AutumnLeafgR.png"
import CobbleStonegR from "../../Assesst/CobbleStonegR.png"
import SlategR from "../../Assesst/SlategR.png"
import PearlBlackgR from "../../Assesst/PearlBlackgR.png"
import BlackgR from "../../Assesst/BlackgR.png"
import ArcticwhitegR from "../../Assesst/ArcticwhitegR.png"

// Raised Center - Matte (PM)
import AlmondR from "../../Assesst/AlmondR.jpeg"
import CornR from "../../Assesst/CornR.jpeg"
import MagnoliaR from "../../Assesst/MagnoliaR.png"
import BritishBuffR from "../../Assesst/BritishBuffR.jpeg"
import LightBeigeR from "../../Assesst/LightBeigeR.jpeg"
import PeanutR from "../../Assesst/PeanutR.jpeg"
import BarleyR from "../../Assesst/BarleyR.png"
import OysterR from "../../Assesst/OysterR.jpeg"
import IrishCreamR from "../../Assesst/IrishCreamR.jpeg"
import BeigeR from "../../Assesst/BeigeR.png"
import SandalR from "../../Assesst/SandalR.png"
import KhakiR from "../../Assesst/KhakiR.jpeg"
import CappuccionR from "../../Assesst/CappuccionR.jpeg"
import TanR from "../../Assesst/TanR.jpeg"
import LarkR from "../../Assesst/LarkR.png"
import BrownR from "../../Assesst/BrownR.png"
import MochaR from "../../Assesst/MochaR.png"
import ChocolateR from "../../Assesst/ChocolateR.png"

// Raised Center - Gloss (PG)
import AlmondgR from "../../Assesst/AlmondgR.png"
import CorngR from "../../Assesst/CorngR.png"
import MagnoliagR from "../../Assesst/MagnoliagR.png"
import BritishBuffgR from "../../Assesst/BritishBuffgR.png"
import LightBeigegR from "../../Assesst/LightBeigegR.png"
import PeanutgR from "../../Assesst/PeanutgR.png"
import BarleygR from "../../Assesst/BarleygR.png"
import OystergR from "../../Assesst/OystergR.png"
import IrishCreamgR from "../../Assesst/IrishCreamgR.png" 
import BeigegR from "../../Assesst/BeigegR.png"
import SandalgR from "../../Assesst/SandalgR.png"
import KhakigR from "../../Assesst/KhakigR.png"
import CappucciongR from "../../Assesst/CappucciongR.png"
import TangR from "../../Assesst/TangR.png"
import LarkgR from "../../Assesst/LarkgR.png"
import BrowngR from "../../Assesst/BrowngR.png"
import MochagR from "../../Assesst/MochagR.png"
import ChocolategR from "../../Assesst/ChocolategR.png"

const OrnaMatte = "/assets/Images/Ornamatte-brochure-3[1]_1.jpg";  
const OrnaMatte2 = "/assets/Images/Ornamatte-brochure-3[1]_2.jpg";
const OrnaMatte3 = "/assets/Images/Ornamatte-brochure-3[1]_3.jpg";
const OrnaMatte4 = "/assets/Images/Ornamatte-brochure-3[1]_4.jpg";

// Helper to generate unique IDs
let nextId = 1;
const generateId = () => nextId++;

// Create product entries with unique IDs
const createProduct = (name, category, subcategory, img) => ({
  id: generateId(),
  name,
  category,
  subcategory,
  img
});

// Store all products in an array
const products = [

  // Shaker - Matte Products (SM)
  createProduct("21369 Pebble Grey-SM", "Shaker", "Matte", pabblegray),
  createProduct("21029 Warm Grey-SM", "Shaker", "Matte", Warmgray),
  createProduct("21109 Moss Grey-SM", "Shaker", "Matte", Mossgray),
  createProduct("22169 Pale Grey-SM", "Shaker", "Matte", Palegray),
  createProduct("21019 Folkstone Grey-SM", "Shaker", "Matte", folkestonefray),
  createProduct("21059 Platinum-SM", "Shaker", "Matte", Platinum),
  createProduct("21071 Smoke-SM", "Shaker", "Matte", smoke),
  createProduct("21069 Silver Grey-SM", "Shaker", "Matte", silvergray),
  createProduct("21161 Ceramic-SM", "Shaker", "Matte", Ceramic),
  createProduct("21187 Champagne-SM", "Shaker", "Matte", Champagne),
  createProduct("24087 Mysore Ivory-SM", "Shaker", "Matte", MysoreIvory),
  createProduct("21341 Interior White-SM", "Shaker", "Matte", InteriorWhite),
  createProduct("21141 Snow White-SM", "Shaker", "Matte", SnowWhite),
  createProduct("21581 Royal White-SM", "Shaker", "Matte", RoyalWhite),
  createProduct("21941 Candy White-SM", "Shaker", "Matte", CandyWhite),
  createProduct("21081 White Lily-SM", "Shaker", "Matte", WhiteLily),
  createProduct("21099 Royal Grey-SM", "Shaker", "Matte", RoyalGrey),
  createProduct("21089 Ash Grey-SM", "Shaker", "Matte", AshGrey),
  createProduct("21009 Grey Stone-SM", "Shaker", "Matte", GreyStone),
  createProduct("21321 Pumic Grey-SM", "Shaker", "Matte", PumicGrey),
  createProduct("22079 Dove Grey-SM", "Shaker", "Matte", DoveGrey),
  createProduct("21039 Misty Grey-SM", "Shaker", "Matte", MistyGrey),
  createProduct("22119 Autumn Leaf-SM", "Shaker", "Matte", AutumnLeaf),
  createProduct("22129 Cobble Stone-SM", "Shaker", "Matte", CobbleStone),
  createProduct("22099 Slate-SM", "Shaker", "Matte", Slate),
  createProduct("22059 Gothic Grey-SG", "Shaker", "Matte", GothicGrey),
  createProduct("22109 Pearl Black-SM", "Shaker", "Matte", PearlBlack),
  createProduct("21066 Black-SM", "Shaker", "Matte", Black),
  createProduct("21087 Almond-SM", "Shaker", "Matte", Almond),
  createProduct("21387 Corn-SM", "Shaker", "Matte", Corn),
  createProduct("21017 Magnolia-SM", "Shaker", "Matte", Magnolia),
  createProduct("22107 British Buff-SM", "Shaker", "Matte", BritishBuff),
  createProduct("21054 Light Beige-SM", "Shaker", "Matte", LightBeige),
  createProduct("21061 Peanut-SM", "Shaker", "Matte", Peanut),
  createProduct("21051 Barley-SM", "Shaker", "Matte", Barley),
  createProduct("21007 Oyster-SM", "Shaker", "Matte", Oyster),
  createProduct("21027 Irish Cream-SM", "Shaker", "Matte", IrishCream),
  createProduct("21037 Beige-SM", "Shaker", "Matte", Beige),
  createProduct("21077 Sandal-SM", "Shaker", "Matte", Sandal),
  createProduct("21097 Khaki-SM", "Shaker", "Matte", Khaki),
  createProduct("22137 Cappuccion-SM", "Shaker", "Matte", Cappuccion),
  createProduct("21127 Tan-SM", "Shaker", "Matte", Tan),
  createProduct("22197 Lark-SM", "Shaker", "Matte", Lark),
  createProduct("22127 Brown-SM", "Shaker", "Matte", Brown),
  createProduct("21038 Mocha-SM", "Shaker", "Matte", Mocha),
  createProduct("21028 Chocolate-SM", "Shaker", "Matte", Chocolate),
  createProduct("22091 Arctic White-SM", "Shaker", "Matte", Arcticwhite),

  // Petit - Matte Products (PM)
 createProduct("21369 Pebble Grey-PM", "Petite", "Matte", pabblegrayP),
createProduct("21029 Warm Grey-PM", "Petite", "Matte", WarmgrayP),
createProduct("21109 Moss Grey-PM", "Petite", "Matte", MossgrayP),
createProduct("22169 Pale Grey-PM", "Petite", "Matte", PalegrayP),
createProduct("21019 Folkstone Grey-PM", "Petite", "Matte", folkestonefrayP),
createProduct("21059 Platinum-PM", "Petite", "Matte", PlatinumP),
createProduct("21071 Smoke-PM", "Petite", "Matte", smokeP),
createProduct("21069 Silver Grey-PM", "Petite", "Matte", silvergrayP),
createProduct("21161 Ceramic-PM", "Petite", "Matte", CeramicP),
createProduct("21187 Champagne-PM", "Petite", "Matte", ChampagneP),
createProduct("24087 Mysore Ivory-PM", "Petite", "Matte", MysoreIvoryP),
createProduct("21341 Interior White-PM", "Petite", "Matte", InteriorWhiteP),
createProduct("21141 Snow White-PM", "Petite", "Matte", SnowWhiteP),
createProduct("21581 Royal White-PM", "Petite", "Matte", RoyalWhiteP),
createProduct("21941 Candy White-PM", "Petite", "Matte", CandyWhiteP),
createProduct("21081 White Lily-PM", "Petite", "Matte", WhiteLilyP),
createProduct("21099 Royal Grey-PM", "Petite", "Matte", RoyalGreyP),
createProduct("21089 Ash Grey-PM", "Petite", "Matte", AshGreyP),
createProduct("21009 Grey Stone-PM", "Petite", "Matte", GreyStoneP),
createProduct("21321 Pumic Grey-PM", "Petite", "Matte", PumicGreyP),
createProduct("22079 Dove Grey-PM", "Petite", "Matte", DoveGreyP),
createProduct("22059 Gothic Grey-PM", "Petite", "Matte", GothicGreyP),
createProduct("21039 Misty Grey-PM", "Petite", "Matte", MistyGreyP),
createProduct("22119 Autumn Leaf-PM", "Petite", "Matte", AutumnLeafP),
createProduct("22129 Cobble Stone-PM", "Petite", "Matte", CobbleStoneP),
createProduct("22099 Slate-PM", "Petite", "Matte", SlateP),
createProduct("22109 Pearl Black-PM", "Petite", "Matte", PearlBlackP),
createProduct("21066 Black-PM", "Petite", "Matte", BlackP),
createProduct("21087 Almond-PM", "Petite", "Matte", AlmondP),
createProduct("21387 Corn-PM", "Petite", "Matte", CornP),
createProduct("21017 Magnolia-PM", "Petite", "Matte", MagnoliaP),
createProduct("22107 British Buff-PM", "Petite", "Matte", BritishBuffP),
createProduct("21054 Light Beige-PM", "Petite", "Matte", LightBeigeP),
createProduct("21061 Peanut-PM", "Petite", "Matte", PeanutP),
createProduct("21051 Barley-PM", "Petite", "Matte", BarleyP),
createProduct("21007 Oyster-PM", "Petite", "Matte", OysterP),
createProduct("21027 Irish Cream-PM", "Petite", "Matte", IrishCreamP),
createProduct("21037 Beige-PM", "Petite", "Matte", BeigeP),
createProduct("21077 Sandal-PM", "Petite", "Matte", SandalP),
createProduct("21097 Khaki-PM", "Petite", "Matte", KhakiP),
createProduct("22137 Cappuccion-PM", "Petite", "Matte", CappuccionP),
createProduct("21127 Tan-PM", "Petite", "Matte", TanP),
createProduct("22197 Lark-PM", "Petite", "Matte", LarkP),
createProduct("22127 Brown-PM", "Petite", "Matte", BrownP),
createProduct("21038 Mocha-PM", "Petite", "Matte", MochaP),
createProduct("21028 Chocolate-PM", "Petite", "Matte", ChocolateP),
createProduct("22091 Arctic White-PM", "Petite", "Matte", ArcticwhiteP),

  // Shaker - Gloss Products (SG)
  createProduct("21369 Pebble Grey-SG", "Shaker", "Gloss", pabblegrayg),
  createProduct("21029 Warm Grey-SG", "Shaker", "Gloss", Warmgrayg),
  createProduct("21109 Moss Grey-SG", "Shaker", "Gloss", Mossgrayg),
  createProduct("22169 Pale Grey-SG", "Shaker", "Gloss", Palegrayg),
  createProduct("21019 Folkstone Grey-SG", "Shaker", "Gloss", folkestonefrayg),
  createProduct("21059 Platinum-SG", "Shaker", "Gloss", Platinumg),
  createProduct("21071 Smoke-SG", "Shaker", "Gloss", smokeg),
  createProduct("21069 Silver Grey-SG", "Shaker", "Gloss", silvergrayg),
  createProduct("21161 Ceramic-SG", "Shaker", "Gloss", Ceramicg),
  createProduct("21187 Champagne-SG", "Shaker", "Gloss", Champagneg),
  createProduct("24087 Mysore Ivory-SG", "Shaker", "Gloss", MysoreIvoryg),
  createProduct("21341 Interior White-SG", "Shaker", "Gloss", InteriorWhiteg),
  createProduct("21141 Snow White-SG", "Shaker", "Gloss", SnowWhiteg),
  createProduct("21581 Royal White-SG", "Shaker", "Gloss", RoyalWhiteg),
  createProduct("21941 Candy White-SG", "Shaker", "Gloss", CandyWhiteg),
  createProduct("21081 White Lily-SG", "Shaker", "Gloss", WhiteLilyg),
  createProduct("21099 Royal Grey-SG", "Shaker", "Gloss", RoyalGreyg),
  createProduct("21089 Ash Grey-SG", "Shaker", "Gloss", AshGreyg),
  createProduct("21009 Grey Stone-SG", "Shaker", "Gloss", GreyStoneg),
  createProduct("21321 Pumic Grey-SG", "Shaker", "Gloss", PumicGreyg),
  createProduct("22059 Gothic Grey-SG", "Shaker", "Gloss", GothicGreyg),
  createProduct("22079 Dove Grey-SG", "Shaker", "Gloss", DoveGreyg),
  createProduct("21039 Misty Grey-SG", "Shaker", "Gloss", MistyGreyg),
  createProduct("22119 Autumn Leaf-SG", "Shaker", "Gloss", AutumnLeafg),
  createProduct("22129 Cobble Stone-SG", "Shaker", "Gloss", CobbleStoneg),
  createProduct("22099 Slate-SG", "Shaker", "Gloss", Slateg),
  createProduct("22109 Pearl Black-SG", "Shaker", "Gloss", PearlBlackg),
  createProduct("21066 Black-SG", "Shaker", "Gloss", Blackg),
  createProduct("21087 Almond-SG", "Shaker", "Gloss", Almondg),
  createProduct("21387 Corn-SG", "Shaker", "Gloss", Corng),
  createProduct("21017 Magnolia-SG", "Shaker", "Gloss", Magnoliag),
  createProduct("22107 British Buff-SG", "Shaker", "Gloss", BritishBuffg),
  createProduct("21054 Light Beige-SG", "Shaker", "Gloss", LightBeigeg),
  createProduct("21061 Peanut-SG", "Shaker", "Gloss", Peanutg),
  createProduct("21051 Barley-SG", "Shaker", "Gloss", Barleyg),
  createProduct("21007 Oyster-SG", "Shaker", "Gloss", Oysterg),
  createProduct("21027 Irish Cream-SG", "Shaker", "Gloss", IrishCreamg),
  createProduct("21037 Beige-SG", "Shaker", "Gloss", Beigeg),
  createProduct("21077 Sandal-SG", "Shaker", "Gloss", Sandalg),
  createProduct("21097 Khaki-SG", "Shaker", "Gloss", Khakig),
  createProduct("22137 Cappuccion-SG", "Shaker", "Gloss", Cappucciong),
  createProduct("21127 Tan-SG", "Shaker", "Gloss", Tang),
  createProduct("22197 Lark-SG", "Shaker", "Gloss", Larkg),
  createProduct("22127 Brown-SG", "Shaker", "Gloss", Browng),
  createProduct("21038 Mocha-SG", "Shaker", "Gloss", Mochag),
  createProduct("21028 Chocolate-SG", "Shaker", "Gloss", Chocolateg),
  createProduct("22091 Arctic White-SG", "Shaker", "Gloss", Arcticwhiteg),

  // Petit - Gloss Products (PG)
  createProduct("21369 Pebble Grey-PG", "Petite", "Gloss", pabblegraygP),
createProduct("21029 Warm Grey-PG", "Petite", "Gloss", WarmgraygP),
createProduct("21109 Moss Grey-PG", "Petite", "Gloss", MossgraygP),
createProduct("22169 Pale Grey-PG", "Petite", "Gloss", PalegraygP),
createProduct("21019 Folkstone Grey-PG", "Petite", "Gloss", folkestonefraygP),
createProduct("21059 Platinum-PG", "Petite", "Gloss", PlatinumgP),
createProduct("21071 Smoke-PG", "Petite", "Gloss", smokegP),
createProduct("21069 Silver Grey-PG", "Petite", "Gloss", silvergraygP),
createProduct("21161 Ceramic-PG", "Petite", "Gloss", CeramicgP),
createProduct("21187 Champagne-PG", "Petite", "Gloss", ChampagnegP),
createProduct("24087 Mysore Ivory-PG", "Petite", "Gloss", MysoreIvorygP),
createProduct("21341 Interior White-PG", "Petite", "Gloss", InteriorWhitegP),
createProduct("21141 Snow White-PG", "Petite", "Gloss", SnowWhitegP),
createProduct("21581 Royal White-PG", "Petite", "Gloss", RoyalWhitegP),
createProduct("21941 Candy White-PG", "Petite", "Gloss", CandyWhitegP),
createProduct("21081 White Lily-PG", "Petite", "Gloss", WhiteLilygP),
createProduct("21099 Royal Grey-PG", "Petite", "Gloss", RoyalGreygP),
createProduct("21089 Ash Grey-PG", "Petite", "Gloss", AshGreygP),
createProduct("21009 Grey Stone-PG", "Petite", "Gloss", GreyStonegP),
createProduct("21321 Pumic Grey-PG", "Petite", "Gloss", PumicGreygP),
createProduct("22079 Dove Grey-PG", "Petite", "Gloss", DoveGreygP),
createProduct("22059 Gothic Grey-PG", "Petite", "Gloss", GothicGreygP),
createProduct("21039 Misty Grey-PG", "Petite", "Gloss", MistyGreygP),
createProduct("22119 Autumn Leaf-PG", "Petite", "Gloss", AutumnLeafgP),
createProduct("22129 Cobble Stone-PG", "Petite", "Gloss", CobbleStonegP),
createProduct("22099 Slate-PG", "Petite", "Gloss", SlategP),
createProduct("22109 Pearl Black-PG", "Petite", "Gloss", PearlBlackgP),
createProduct("21066 Black-PG", "Petite", "Gloss", BlackgP),
createProduct("21087 Almond-PG", "Petite", "Gloss", AlmondgP),
createProduct("21387 Corn-PG", "Petite", "Gloss", CorngP),
createProduct("21017 Magnolia-PG", "Petite", "Gloss", MagnoliagP),
createProduct("22107 British Buff-PG", "Petite", "Gloss", BritishBuffgP),
createProduct("21054 Light Beige-PG", "Petite", "Gloss", LightBeigegP),
createProduct("21061 Peanut-PG", "Petite", "Gloss", PeanutgP),
createProduct("21051 Barley-PG", "Petite", "Gloss", BarleygP),
createProduct("21007 Oyster-PG", "Petite", "Gloss", OystergP),
createProduct("21027 Irish Cream-PG", "Petite", "Gloss", IrishCreamgP),
createProduct("21037 Beige-PG", "Petite", "Gloss", BeigegP),
createProduct("21077 Sandal-PG", "Petite", "Gloss", SandalgP),
createProduct("21097 Khaki-PG", "Petite", "Gloss", KhakigP),
createProduct("22137 Cappuccion-PG", "Petite", "Gloss", CappucciongP),
createProduct("21127 Tan-PG", "Petite", "Gloss", TangP),
createProduct("22197 Lark-PG", "Petite", "Gloss", LarkgP),
createProduct("22127 Brown-PG", "Petite", "Gloss", BrowngP),
createProduct("21038 Mocha-PG", "Petite", "Gloss", MochagP),
createProduct("21028 Chocolate-PG", "Petite", "Gloss", ChocolategP),
createProduct("22091 Arctic White-PG", "Petite", "Gloss", ArcticwhitegP),



  // Raised Center MATTE 

  createProduct("21369 Pebble Grey-RCM", "Raised Center", "Matte", pabblegrayR),
createProduct("21029 Warm Grey-RCM", "Raised Center", "Matte", WarmgrayR),
createProduct("21109 Moss Grey-RCM", "Raised Center", "Matte", MossgrayR),
createProduct("22169 Pale Grey-RCM", "Raised Center", "Matte", PalegrayR),
createProduct("21019 Folkstone Grey-RCM", "Raised Center", "Matte", folkestonefrayR),
createProduct("21059 Platinum-RCM", "Raised Center", "Matte", PlatinumR),
createProduct("21071 Smoke-RCM", "Raised Center", "Matte", smokeR),
createProduct("21069 Silver Grey-RCM", "Raised Center", "Matte", silvergrayR),
createProduct("21161 Ceramic-RCM", "Raised Center", "Matte", CeramicR),
createProduct("21187 Champagne-RCM", "Raised Center", "Matte", ChampagneR),
createProduct("24087 Mysore Ivory-RCM", "Raised Center", "Matte", MysoreIvoryR),
createProduct("21341 Interior White-RCM", "Raised Center", "Matte", InteriorWhiteR),
createProduct("21141 Snow White-RCM", "Raised Center", "Matte", SnowWhiteR),
createProduct("21581 Royal White-RCM", "Raised Center", "Matte", RoyalWhiteR),
createProduct("21941 Candy White-RCM", "Raised Center", "Matte", CandyWhiteR),
createProduct("21081 White Lily-RCM", "Raised Center", "Matte", WhiteLilyR),
createProduct("21099 Royal Grey-RCM", "Raised Center", "Matte", RoyalGreyR),
createProduct("21089 Ash Grey-RCM", "Raised Center", "Matte", AshGreyR),
createProduct("21009 Grey Stone-RCM", "Raised Center", "Matte", GreyStoneR),
createProduct("21321 Pumic Grey-RCM", "Raised Center", "Matte", PumicGreyR),
createProduct("22079 Dove Grey-RCM", "Raised Center", "Matte", DoveGreyR),
createProduct("22059 Gothic Grey-RCM", "Raised Center", "Matte", GothicGreyR),
createProduct("21039 Misty Grey-RCM", "Raised Center", "Matte", MistyGreyR),
createProduct("22119 Autumn Leaf-RCM", "Raised Center", "Matte", AutumnLeafR),
createProduct("22129 Cobble Stone-RCM", "Raised Center", "Matte", CobbleStoneR),
createProduct("22099 Slate-RCM", "Raised Center", "Matte", SlateR),
createProduct("22109 Pearl Black-RCM", "Raised Center", "Matte", PearlBlackR),
createProduct("21066 Black-RCM", "Raised Center", "Matte", BlackR),
createProduct("21087 Almond-RCM", "Raised Center", "Matte", AlmondR),
createProduct("21387 Corn-RCM", "Raised Center", "Matte", CornR),
createProduct("21017 Magnolia-RCM", "Raised Center", "Matte", MagnoliaR),
createProduct("22107 British Buff-RCM", "Raised Center", "Matte", BritishBuffR),
createProduct("21054 Light Beige-RCM", "Raised Center", "Matte", LightBeigeR),
createProduct("21061 Peanut-RCM", "Raised Center", "Matte", PeanutR),
createProduct("21051 Barley-RCM", "Raised Center", "Matte", BarleyR),
createProduct("21007 Oyster-RCM", "Raised Center", "Matte", OysterR),
createProduct("21027 Irish Cream-RCM", "Raised Center", "Matte", IrishCreamR),
createProduct("21037 Beige-RCM", "Raised Center", "Matte", BeigeR),
createProduct("21077 Sandal-RCM", "Raised Center", "Matte", SandalR),
createProduct("21097 Khaki-RCM", "Raised Center", "Matte", KhakiR),
createProduct("22137 Cappuccion-RCM", "Raised Center", "Matte", CappuccionR),
createProduct("21127 Tan-RCM", "Raised Center", "Matte", TanR),
createProduct("22197 Lark-RCM", "Raised Center", "Matte", LarkR),
createProduct("22127 Brown-RCM", "Raised Center", "Matte", BrownR),
createProduct("21038 Mocha-RCM", "Raised Center", "Matte", MochaR),
createProduct("21028 Chocolate-RCM", "Raised Center", "Matte", ChocolateR),
createProduct("22091 Arctic White-RCM", "Raised Center", "Matte", ArcticwhiteR),



// Raised Center gloss

  createProduct("21369 Pebble Grey-RCG", "Raised Center", "Gloss", pabblegraygR),
createProduct("21029 Warm Grey-RCG", "Raised Center", "Gloss", WarmgraygR),
createProduct("21109 Moss Grey-RCG", "Raised Center", "Gloss", MossgraygR),
createProduct("22169 Pale Grey-RCG", "Raised Center", "Gloss", PalegraygR),
createProduct("21019 Folkstone Grey-RCG", "Raised Center", "Gloss", folkestonefraygR),
createProduct("21059 Platinum-RCG", "Raised Center", "Gloss", PlatinumgR),
createProduct("21071 Smoke-RCG", "Raised Center", "Gloss", smokegR),
createProduct("21069 Silver Grey-RCG", "Raised Center", "Gloss", silvergraygR),
createProduct("21161 Ceramic-RCG", "Raised Center", "Gloss", CeramicgR),
createProduct("21187 Champagne-RCG", "Raised Center", "Gloss", ChampagnegR),
createProduct("24087 Mysore Ivory-RCG", "Raised Center", "Gloss", MysoreIvorygR),
createProduct("21341 Interior White-RCG", "Raised Center", "Gloss", InteriorWhitegR),
createProduct("21141 Snow White-RCG", "Raised Center", "Gloss", SnowWhitegR),
createProduct("21581 Royal White-RCG", "Raised Center", "Gloss", RoyalWhitegR),
createProduct("21941 Candy White-RCG", "Raised Center", "Gloss", CandyWhitegR),
createProduct("21081 White Lily-RCG", "Raised Center", "Gloss", WhiteLilygR),
createProduct("21099 Royal Grey-RCG", "Raised Center", "Gloss", RoyalGreygR),
createProduct("21089 Ash Grey-RCG", "Raised Center", "Gloss", AshGreygR),
createProduct("21009 Grey Stone-RCG", "Raised Center", "Gloss", GreyStonegR),
createProduct("21321 Pumic Grey-RCG", "Raised Center", "Gloss", PumicGreygR),
createProduct("22079 Dove Grey-RCG", "Raised Center", "Gloss", DoveGreygR),
createProduct("22059 Gothic Grey-RCG", "Raised Center", "Gloss", GothicGreygR),
createProduct("21039 Misty Grey-RCG", "Raised Center", "Gloss", MistyGreygR),
createProduct("22119 Autumn Leaf-RCG", "Raised Center", "Gloss", AutumnLeafgR),
createProduct("22129 Cobble Stone-RCG", "Raised Center", "Gloss", CobbleStonegR),
createProduct("22099 Slate-RCG", "Raised Center", "Gloss", SlategR),
createProduct("22109 Pearl Black-RCG", "Raised Center", "Gloss", PearlBlackgR),
createProduct("21066 Black-RCG", "Raised Center", "Gloss", BlackgR),
createProduct("21087 Almond-RCG", "Raised Center", "Gloss", AlmondgR),
createProduct("21387 Corn-RCG", "Raised Center", "Gloss", CorngR),
createProduct("21017 Magnolia-RCG", "Raised Center", "Gloss", MagnoliagR),
createProduct("22107 British Buff-RCG", "Raised Center", "Gloss", BritishBuffgR),
createProduct("21054 Light Beige-RCG", "Raised Center", "Gloss", LightBeigegR),
createProduct("21061 Peanut-RCG", "Raised Center", "Gloss", PeanutgR),
createProduct("21051 Barley-RCG", "Raised Center", "Gloss", BarleygR),
createProduct("21007 Oyster-RCG", "Raised Center", "Gloss", OystergR),
createProduct("21027 Irish Cream-RCG", "Raised Center", "Gloss", IrishCreamgR),
createProduct("21037 Beige-RCG", "Raised Center", "Gloss", BeigegR),
createProduct("21077 Sandal-RCG", "Raised Center", "Gloss", SandalgR),
createProduct("21097 Khaki-RCG", "Raised Center", "Gloss", KhakigR),
createProduct("22137 Cappuccion-RCG", "Raised Center", "Gloss", CappucciongR),
createProduct("21127 Tan-RCG", "Raised Center", "Gloss", TangR),
createProduct("22197 Lark-RCG", "Raised Center", "Gloss", LarkgR),
createProduct("22127 Brown-RCG", "Raised Center", "Gloss", BrowngR),
createProduct("21038 Mocha-RCG", "Raised Center", "Gloss", MochagR),
createProduct("21028 Chocolate-RCG", "Raised Center", "Gloss", ChocolategR),
createProduct("22091 Arctic White-RCM", "Raised Center", "Gloss", ArcticwhitegR),


  // Ornamatte Products
  createProduct("Ornamatte 1", "Ornamatte", null, OrnaMatte),
  createProduct("Ornamatte 2", "Ornamatte", null, OrnaMatte2),
  createProduct("Ornamatte 3", "Ornamatte", null, OrnaMatte3),
  createProduct("Ornamatte 4", "Ornamatte", null, OrnaMatte4),
];

export default function EcommerceFilter() {
  const [search, setSearch] = useState("");
  const [fullscreenProduct, setFullscreenProduct] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedSubcategory, setSelectedSubcategory] = useState(null);

  const categories = useMemo(() => [...new Set(products.map((p) => p.category))], []);

  const handleCategoryClick = (category) => {
    if (selectedCategory === category) {
      // If clicking the same category, clear everything
      setSelectedCategory(null);
      setSelectedSubcategory(null);
    } else {
      // Select new category
      setSelectedCategory(category);
      setSelectedSubcategory(null);
    }
  };

  const handleSubcategoryClick = (subcategory) => {
    setSelectedSubcategory(subcategory);
  };

  const clearFilters = () => {
    setSelectedCategory(null);
    setSelectedSubcategory(null);
    setSearch("");
  };

  const filteredProducts = products.filter((p) => {
    const matchesSearch = p.name.toLowerCase().includes(search.toLowerCase());
    
    // If no category is selected, show all products
    if (!selectedCategory) {
      return matchesSearch;
    }
    
    // If a specific category is selected (including Shaker, Petit, or Raised Center)
    // Only show products that match exactly that category
    if (selectedCategory !== "Shaker" && selectedCategory !== "Petite" && selectedCategory !== "Raised Center") {
      return matchesSearch && p.category === selectedCategory;
    }
    
    // For Shaker, Petit, and Raised Center categories
    if (selectedCategory === "Shaker" || selectedCategory === "Petite" || selectedCategory === "Raised Center") {
      // If subcategory is selected, only show products with that subcategory
      if (selectedSubcategory) {
        return matchesSearch && p.category === selectedCategory && p.subcategory === selectedSubcategory;
      }
      // If no subcategory selected, show all products of that category
      return matchesSearch && p.category === selectedCategory;
    }
    
    return matchesSearch;
  });

  return (
    <div className="flex flex-col min-h-screen">
      {/* Main Content */}
      <div className="flex-1 p-8 overflow-y-auto" style={{ backgroundColor: "var(--color-gray-50)" }}>

      <h1 className="text-5xl md:text-7xl font-semibold text-center mb-6 p-5 tracking-wide bell-mt-primary" style={{ color: "var(--color-primary-500)" }}>
          Our Brochure
      </h1>
        
        {/* Category Filter Bar */}
        <div className="flex flex-wrap justify-center gap-3 mb-8">
          {categories.map((category) => (
            <button
              key={category}
              onClick={() => handleCategoryClick(category)}
              className={`px-6 py-2 rounded-full font-semibold transition-all shadow-md hover:shadow-lg ${
                selectedCategory === category ? "ring-2 ring-offset-2 ring-gray-400" : ""
              }`}
              style={{
                backgroundColor: selectedCategory === category ? "#6B7280" : "var(--color-primary-500)",
                color: selectedCategory === category ? "white" : "var(--color-white)",
              }}
            >
              {category}
            </button>
          ))}
        </div>

        {/* Search Bar */}
        <div className="flex justify-center mb-8">
          <input
            type="text"
            placeholder="🔍 Search product..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="w-full max-w-md border text-black p-3 rounded-lg focus:outline-none focus:ring-2 inter-secondary"
            style={{
              borderColor: "var(--border-light)",
            }}
          />
        </div>

        {/* Subcategory Filter Bar - Shows when Shaker, Petit, or Raised Center is selected */}
        {(selectedCategory === "Shaker" || selectedCategory === "Petite" || selectedCategory === "Raised Center") && (
          <div className="flex justify-center gap-4 mb-8">
            <button
              onClick={() => handleSubcategoryClick("Matte")}
              className={`px-6 py-2 rounded-full font-semibold transition-all shadow-md hover:shadow-lg ${
                selectedSubcategory === "Matte" ? "ring-2 ring-offset-2 ring-gray-400" : ""
              }`}
              style={{
                backgroundColor: selectedSubcategory === "Matte" ? "#6B7280" : "var(--color-primary-500)",
                color: "white",
              }}
            >
              Matte
            </button>
            <button
              onClick={() => handleSubcategoryClick("Gloss")}
              className={`px-6 py-2 rounded-full font-semibold transition-all shadow-md hover:shadow-lg ${
                selectedSubcategory === "Gloss" ? "ring-2 ring-offset-2 ring-gray-400" : ""
              }`}
              style={{
                backgroundColor: selectedSubcategory === "Gloss" ? "#6B7280" : "var(--color-primary-500)",
                color: "white",
              }}
            >
              Gloss
            </button>
          </div>
        )}

        {/* Active Filter Display */}
        {(selectedCategory || selectedSubcategory || search) && (
          <div className="flex justify-center gap-3 mb-6 flex-wrap">
            {selectedCategory && (
              <div 
                className="flex items-center gap-2 px-4 py-2 rounded-full shadow-md inter-secondary"
                style={{
                  backgroundColor: "var(--color-primary-100)",
                  color: "var(--color-primary-700)",
                }}
              >
                <span className="font-bold">
                  {selectedCategory}
                  {selectedSubcategory && ` - ${selectedSubcategory}`}
                </span>
                <button
                  onClick={clearFilters}
                  className="text-lg font-bold transition hover:opacity-70"
                  style={{ color: "var(--color-primary-700)" }}
                  aria-label="Clear filter"
                >
                  ✕
                </button>
              </div>
            )}
            {search && (
              <div 
                className="flex items-center gap-2 px-4 py-2 rounded-full shadow-md inter-secondary"
                style={{
                  backgroundColor: "var(--color-primary-100)",
                  color: "var(--color-primary-700)",
                }}
              >
                <span className="font-bold">Search: {search}</span>
                <button
                  onClick={() => setSearch("")}
                  className="text-lg font-bold transition hover:opacity-70"
                  style={{ color: "var(--color-primary-700)" }}
                  aria-label="Clear search"
                >
                  ✕
                </button>
              </div>
            )}
          </div>
        )}

        {/* Products List */}
        {filteredProducts.length > 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 place-items-center">
            {filteredProducts.map((p) => (
              <div
                key={p.id}
                className="w-full md:w-[75%] cursor-pointer flex flex-col items-center bg-white rounded-xl shadow-lg transition transform hover:-translate-y-1 overflow-hidden mx-auto hover:shadow-2xl"
                style={{
                  backgroundColor: "var(--color-white)",
                  boxShadow: p.category === "Ornamatte" 
                    ? "0 0 0 4px var(--color-primary-500), 0 20px 25px -5px rgba(0,0,0,0.1)" 
                    : "var(--shadow-medium)",
                }}
                onClick={() => setFullscreenProduct(p)}
              >
                <img
                  src={p.img}
                  alt={p.name}
                  loading="lazy"
                  className="w-full h-auto max-h-[75vh] object-contain rounded-md"
                />
                <p
                  className="text-xl font-bold py-4 text-center bell-mt-primary"
                  style={{
                    color: p.category === "Ornamatte" ? "var(--color-primary-600)" : "var(--color-gray-900)",
                  }}
                >
                  {p.name} {p.subcategory && `(${p.subcategory})`}
                </p>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-lg text-center pt-20 inter-secondary" style={{ color: "var(--color-gray-600)" }}>
            No products found
          </p>
        )}
      </div>

      {/* Fullscreen Modal - Centered Image Without Name */}
      {fullscreenProduct && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-90 flex items-center justify-center z-50"
          onClick={() => setFullscreenProduct(null)}
        >
          <button
            className="absolute top-6 right-6 text-4xl font-bold transition hover:opacity-70 z-50"
            style={{ color: "var(--color-white)" }}
            onClick={(e) => {
              e.stopPropagation();
              setFullscreenProduct(null);
            }}
            aria-label="Close fullscreen view"
          >
            ✕
          </button>
          <div 
            onClick={(e) => e.stopPropagation()}
            className="flex items-center justify-center w-full h-full"
          >
            <img
              src={fullscreenProduct.img}
              alt={fullscreenProduct.name}
              loading="lazy"
              className="max-h-[90%] max-w-[90%] object-contain rounded-xl shadow-xl"
            />
          </div>
        </div>
      )}
    </div>
  );
}